module.exports = __webpack_public_path__ + "static/media/52.bd01fc4d.png";